// Define spacing sizes for desktop and mobile
const spacingClasses = {
    pt: {
        xs: 'pt-xs',
        s: 'pt-s',
        m: 'pt-m',
        l: 'pt-l',
        xl: 'pt-xl',
        '3xl': 'pt-3xl',
        '4xl': 'pt-4xl',
        '5xl': 'pt-5xl',
        '6xl': 'pt-6xl',
        '7xl': 'pt-7xl',
    },
    mdPt: {
        xs: 'md:pt-xs',
        s: 'md:pt-s',
        m: 'md:pt-m',
        l: 'md:pt-l',
        xl: 'md:pt-xl',
        '3xl': 'md:pt-3xl',
        '4xl': 'md:pt-4xl',
        '5xl': 'md:pt-5xl',
        '6xl': 'md:pt-6xl',
        '7xl': 'md:pt-7xl',
    },
    pb: {
        xs: 'pb-xs',
        s: 'pb-s',
        m: 'pb-m',
        l: 'pb-l',
        xl: 'pb-xl',
        '3xl': 'pb-3xl',
        '4xl': 'pb-4xl',
        '5xl': 'pb-5xl',
        '6xl': 'pb-6xl',
        '7xl': 'pb-7xl',
    },
    mdPb: {
        xs: 'md:pb-xs',
        s: 'md:pb-s',
        m: 'md:pb-m',
        l: 'md:pb-l',
        xl: 'md:pb-xl',
        '3xl': 'md:pb-3xl',
        '4xl': 'md:pb-4xl',
        '5xl': 'md:pb-5xl',
        '6xl': 'md:pb-6xl',
        '7xl': 'md:pb-7xl',
    },
    pl: {
        xs: 'pl-xs',
        s: 'pl-s',
        m: 'pl-m',
        l: 'pl-l',
        xl: 'pl-xl',
        '3xl': 'pl-3xl',
        '4xl': 'pl-4xl',
        '5xl': 'pl-5xl',
        '6xl': 'pl-6xl',
        '7xl': 'pl-7xl',
    },
    mdPl: {
        xs: 'md:pl-xs',
        s: 'md:pl-s',
        m: 'md:pl-m',
        l: 'md:pl-l',
        xl: 'md:pl-xl',
        '3xl': 'md:pl-3xl',
        '4xl': 'md:pl-4xl',
        '5xl': 'md:pl-5xl',
        '6xl': 'md:pl-6xl',
        '7xl': 'md:pl-7xl',
    },
    pr: {
        xs: 'pr-xs',
        s: 'pr-s',
        m: 'pr-m',
        l: 'pr-l',
        xl: 'pr-xl',
        '3xl': 'pr-3xl',
        '4xl': 'pr-4xl',
        '5xl': 'pr-5xl',
        '6xl': 'pr-6xl',
        '7xl': 'pr-7xl',
    },
    mdPr: {
        xs: 'md:pr-xs',
        s: 'md:pr-s',
        m: 'md:pr-m',
        l: 'md:pr-l',
        xl: 'md:pr-xl',
        '3xl': 'md:pr-3xl',
        '4xl': 'md:pr-4xl',
        '5xl': 'md:pr-5xl',
        '6xl': 'md:pr-6xl',
        '7xl': 'md:pr-7xl',
    },
    mt: {
        xs: 'mt-xs',
        s: 'mt-s',
        m: 'mt-m',
        l: 'mt-l',
        xl: 'mt-xl',
        '3xl': 'mt-3xl',
        '4xl': 'mt-4xl',
        '5xl': 'mt-5xl',
        '6xl': 'mt-6xl',
        '7xl': 'mt-7xl',
    },
    mdMt: {
        xs: 'md:mt-xs',
        s: 'md:mt-s',
        m: 'md:mt-m',
        l: 'md:mt-l',
        xl: 'md:mt-xl',
        '3xl': 'md:mt-3xl',
        '4xl': 'md:mt-4xl',
        '5xl': 'md:mt-5xl',
        '6xl': 'md:mt-6xl',
        '7xl': 'md:mt-7xl',
    },
    mb: {
        xs: 'mb-xs',
        s: 'mb-s',
        m: 'mb-m',
        l: 'mb-l',
        xl: 'mb-xl',
        '3xl': 'mb-3xl',
        '4xl': 'mb-4xl',
        '5xl': 'mb-5xl',
        '6xl': 'mb-6xl',
        '7xl': 'mb-7xl',
    },
    mdMb: {
        xs: 'md:mb-xs',
        s: 'md:mb-s',
        m: 'md:mb-m',
        l: 'md:mb-l',
        xl: 'md:mb-xl',
        '3xl': 'md:mb-3xl',
        '4xl': 'md:mb-4xl',
        '5xl': 'md:mb-5xl',
        '6xl': 'md:mb-6xl',
        '7xl': 'md:mb-7xl',
    },
    mdMl: {
        xs: 'md:ml-xs',
        s: 'md:ml-s',
        m: 'md:ml-m',
        l: 'md:ml-l',
        xl: 'md:ml-xl',
        '3xl': 'md:ml-3xl',
        '4xl': 'md:ml-4xl',
        '5xl': 'md:ml-5xl',
        '6xl': 'md:ml-6xl',
        '7xl': 'md:ml-7xl',
    },
    mdMr: {
        xs: 'md:mr-xs',
        s: 'md:mr-s',
        m: 'md:mr-m',
        l: 'md:mr-l',
        xl: 'md:mr-xl',
        '3xl': 'md:mr-3xl',
        '4xl': 'md:mr-4xl',
        '5xl': 'md:mr-5xl',
        '6xl': 'md:mr-6xl',
        '7xl': 'md:mr-7xl',
    },
    ml: {
        xs: 'ml-xs',
        s: 'ml-s',
        m: 'ml-m',
        l: 'ml-l',
        xl: 'ml-xl',
        '3xl': 'ml-3xl',
        '4xl': 'ml-4xl',
        '5xl': 'ml-5xl',
        '6xl': 'ml-6xl',
        '7xl': 'ml-7xl',
    },
    mr: {
        xs: 'mr-xs',
        s: 'mr-s',
        m: 'mr-m',
        l: 'mr-l',
        xl: 'mr-xl',
        '3xl': 'mr-3xl',
        '4xl': 'mr-4xl',
        '5xl': 'mr-5xl',
        '6xl': 'mr-6xl',
        '7xl': 'mr-7xl',
    },
};

export default spacingClasses;